import { Field, Form, FormikContextType, FormikProvider } from "formik";
import { Checkbox, FormControlLabel, FormControlProps, FormGroup, FormGroupProps } from "@mui/material";

export type AppCheckBoxOption = {
    label: string;
    value: string;
    linkLabel?: React.ReactNode;
};

export type AppCheckBoxesValues = Record<string, boolean>;

export interface AppCheckBoxesProps<V> {
    options: AppCheckBoxOption[];
    formik: FormikContextType<V>;
    formControlProps?: FormControlProps;
}

function AppCheckBoxes<V = AppCheckBoxesValues>(props: AppCheckBoxesProps<V>) {
    const { options, formik } = props;

    const formGroupProps: FormGroupProps = {
        sx: {
            alignItems: "flex-start",
        },
    };

    return (
        <FormikProvider value={formik}>
            <Form>
                <FormGroup {...formGroupProps}>
                    {options.map(option => (
                        <Field
                            type="checkbox"
                            key={option.value}
                            name={option.value}
                            label={option.linkLabel ? option.linkLabel : option.label}
                            as={FormControlLabel}
                            control={<Checkbox />}
                            {...props.formControlProps}
                            sx={{
                                "& .MuiFormControlLabel-label": {
                                    fontSize: 14,
                                },
                                ml: 0,
                                "&:not(:last-child)": {
                                    mb: 2,
                                },
                                alignItems: "flex-start",
                                "& .MuiButtonBase-root": {
                                    marginTop: -1.25,
                                },
                                ...props.formControlProps?.sx,
                            }}
                        />
                    ))}
                </FormGroup>
            </Form>
        </FormikProvider>
    );
}

export default AppCheckBoxes;
